import React, { useMemo } from 'react';

import { LockboxStatus, LockboxType } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';
import { FeatureFlags, useFeatureFlag } from '@/modules/featureFlags';

import SelectChecks from './SelectChecks';

const LockboxChecks = () => {
  const { originalLockbox, editableLockbox, isDividingMode } = useLockboxDetailsStore();
  const isReturnedChecksEnabled = useFeatureFlag(FeatureFlags.RETURNED_CHECKS_LOCKBOX);

  const isAvailable = useMemo(
    () => editableLockbox?.lockboxType === LockboxType.RETURNED_CHECK
      && isReturnedChecksEnabled
      && originalLockbox?.lockboxStatus !== LockboxStatus.DIVIDED,
    [editableLockbox?.lockboxType, isReturnedChecksEnabled, originalLockbox?.lockboxStatus]
  );

  if (!isAvailable || isDividingMode || editableLockbox?.isMultipleRecordsWarning) {
    return null;
  }

  return <SelectChecks />;
};

export default LockboxChecks;
